const recruitmentList = [
    {
        "Id":1,
        "Title":"研发工程师",
        "Content":"1、新产品开发管理：负责新产品开发的全流程管理，包括市场调研、立项、方案设计、开发实施、试产与量产导入，并对开发成本、进度和质量进行闭环控制。\n" +
            "2、生产技术支援与品质改善：参与生产过程中的技术问题分析、攻关与解决方案制定，推动生产工艺优化与标准化，促进产品品质的持续提升与稳定性改善。\n" +
            "3、团队与项目管理：负责课题组日常工作的计划、分配与协调，确保研发任务的顺利完成；同时进行信息搜集、技术资料整理与团队能力建设。",
        "Condition":"1、化学、电化学、材料等相关专业，专业成绩优异；\n" +
            "2、有阳极氧化、电化学腐蚀相关课题或项目经验，具备独立的实验操作、设计、分析能力；\n" +
            "3、硕士及以上学历，博士优先。",
        "Link1":"https://xiaoyuan.zhaopin.com/company/KA0209705138D90000071000?refcode=4440",
        "Link2":"https://xyz.51job.com/External/Apply.aspx?CtmID=8912218"
    },
    {
        "Id":2,
        "Title":"电气工程师",
        "Content":"1、独立完成自动化控制项目的整体方案设计与技术规划，专长于PLC等工业控制软件的架构设计与程序，为项目从建设、安装至调试、运行的全生命周期提供核心技术保障。\n" +
            "2、主导设备电气系统的设计与开发，负责系统调试及后续优化跟踪、开发。\n" +
            "3、具备精准的电气系统成本核算与材料清单管理能力，能够实施电气项目的全流程管控，确保项目高质量交付。\n" +
            "4、承担关键技术文档的编制与审核工作，并能根据项目需要，为客户与现场团队提供及时、专业的技术支持。",
        "Condition":"1、电气、自动化等相关专业，专业成绩优异；\n" +
            "2、熟练查阅期刊和专利；\n" +
            "3、本科及以上学历。",
        "Link1":"https://xiaoyuan.zhaopin.com/company/KA0209705138D90000071000?refcode=4440",
        "Link2":"https://xyz.51job.com/External/Apply.aspx?CtmID=8912218"
    },
    {
        "Id":3,
        "Title":"机械工程师",
        "Content":"1、负责生产系统、核心设备及关键部件的设计与研发，主导技术方案的规划与图纸绘制工作。\n" +
            "2、致力于推动现有设备与系统的持续优化与智能化升级，显著提升其运行效率、可靠性及综合性能。\n" +
            "3、深度参与关键设备的制造、技术改造、现场安装、系统调试及全生命周期维护管理，为生产体系的稳定与高效运行提供全面技术保障。",
        "Condition":"1、机械工程、机械设计、智能制造等机械相关专业，专业成绩优异；\n" +
            "2、熟练查阅期刊和专利；\n" +
            "3、本科及以上学历。",
        "Link1":"https://xiaoyuan.zhaopin.com/company/KA0209705138D90000071000?refcode=4440",
        "Link2":"https://xyz.51job.com/External/Apply.aspx?CtmID=8912218"
    },
    {
        "Id":4,
        "Title":"工艺工程师",
        "Content":"1、参与制定并完善核心工艺控制参数的标准与体系规范。\n" +
            "2、主导生产过程控制策略的持续优化，通过系统性跟踪与监督，确保工艺运行的极致稳定与高效。\n" +
            "3、深度参与新工艺技术的导入与调试，组织领导产品档次提升及全面品质改善专项活动。\n" +
            "4、协同推进生产管理优化，为实现关键任务指标提供坚实的技术与管理支持。",
        "Condition":"1、化学、金属腐蚀与防护、材料、化工工艺及相关专业，专业成绩优异；\n" +
            "2、本科及以上学历。",
        "Link1":"https://xiaoyuan.zhaopin.com/company/KA0209705138D90000071000?refcode=4440",
        "Link2":"https://xyz.51job.com/External/Apply.aspx?CtmID=8912218"
    },
    {
        "Id":5,
        "Title":"质量工程师",
        "Content":"1、进行产品外观巡视与异常反馈，指导人员完成产品检测、检验及原料测试；\n" +
            "2、完成生产现场质量异常处理，组织质量问题分析，推动整改及效果验证；\n" +
            "3、质量数据统计分析，输出质量报表，监控关键质量指标；\n" +
            "4、负责不合格品评审处置，防止不良品流出。",
        "Condition":"1、质量管理工程、测控技术与仪器、化学、材料学等理工科专业，专业成绩优异；\n" +
            "2、本科及以上学历。",
        "Link1":"https://xiaoyuan.zhaopin.com/company/KA0209705138D90000071000?refcode=4440",
        "Link2":"https://xyz.51job.com/External/Apply.aspx?CtmID=8912218"
    },
    {
        "Id":6,
        "Title":"财务管理",
        "Content":"1、独立承担子公司全盘财务核算工作，按时出具子公司各类财务报表，输出月度、季度、年度财务分析数据，支撑经营决策；\n" +
            "2、参与子公司成本管控工作，梳理成本逻辑，迭代、优化成本考核模型；\n" +
            "3、负责子公司全税种纳税申报工作，保障税务申报准确合规，规避重大税务风险；\n" +
            "4、配合外部审计机构开展工作，整理提供审计所需财务资料，保障子公司年度财务审计顺利完成。",
        "Condition":"1、会计学、财务管理等相关专业，专业成绩优异；\n" +
            "2、本科及以上学历。",
        "Link1":"https://xiaoyuan.zhaopin.com/company/KA0209705138D90000071000?refcode=4440",
        "Link2":"https://xyz.51job.com/External/Apply.aspx?CtmID=8912218"
    },
    {
        "Id":7,
        "Title":"生产管理",
        "Content":"1、负责全面产能评估与资源优化配置，通过系统性持续改善推动生产效率显著提升，为生产线提供高阶技术解决方案与决策支持。\n" +
            "2、主导作业方式创新与线平衡优化，致力于全面提升作业效率，精准降低材料损耗与报废率，实现成本节约与价值提升。\n" +
            "3、开展标准化体系的分析与研究，制定并推行标准化管理流程，全面提升生产管理水平与运营效率。",
        "Condition":"1、工业工程、化学、材料、机电等相关专业，专业成绩优异；\n" +
            "2、本科及以上学历。",
        "Link1":"https://xiaoyuan.zhaopin.com/company/KA0209705138D90000071000?refcode=4440",
        "Link2":"https://xyz.51job.com/External/Apply.aspx?CtmID=8912218"
    },
    {
        "Id":8,
        "Title":"管理培训生",
        "Content":"1、系统性轮岗与高阶任务交付：深入公司核心业务板块完成轮岗实践，承担关键岗位工作任务，交付卓越业绩，构建全局视野与跨领域协同能力。\n" +
            "2、战略性项目攻坚与赋能：主导或深度参与公司阶段性战略项目，从前瞻规划到落地执行，为业务创新与管理升级注入新动能。\n" +
            "3、精准自我定位与加速成长：在实战中持续进行自我复盘与职业定位，快速提升商业洞察、战略思维与复杂问题解决能力，实现职业能力的体系化进阶。",
        "Condition":"1、专业不限，成绩优异；\n" +
            "2、本科及以上学历。",
        "Link1":"https://xiaoyuan.zhaopin.com/company/KA0209705138D90000071000?refcode=4440",
        "Link2":"https://xyz.51job.com/External/Apply.aspx?CtmID=8912218"
    }
]

export function getList() {
    return recruitmentList
}



// WEBPACK FOOTER //
// ./src/mock/recruitment.js